import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAeCfs4_yeil9e-M7oejq7swG8D9zin25U",
  authDomain: "okbikemechanics-8255d.firebaseapp.com",
  projectId: "okbikemechanics-8255d",
  storageBucket: "okbikemechanics-8255d.firebasestorage.app",
  messagingSenderId: "1011019660992",
  appId: "1:1011019660992:web:c103fc495e18e1d3b3b725"
};
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);